import { postRequest } from 'helpers/axios';

export const subscribeToNewsletter = (name, email) => {
  const body = { newsletter_subscription: { name, email } };

  return postRequest(`newsletter_subscriptions`, body);
};
